import React from 'react'

const Text = ({ children, ...other }) => (
  <p css={{ fontSize: '1.14285714rem' }} {...other}>
    {children}
  </p>
)

export default Text
